import React from "react";
import { useEffect, useState } from "react";
import DashboardCard from "../../../components/DashboardCard";
import MyFiles from "../../../assets/images/MyFiles.svg";
import { useHistory } from "react-router-dom";
import { useLocation } from "react-router";
import { useRecoilState, useRecoilValue } from "recoil";
import { permissionsSelector } from "../../Login/selectors/permissionSelector";
import { ShieldCheckIcon } from "@heroicons/react/24/solid";
import { HubConnection, HubConnectionBuilder } from "@microsoft/signalr";
import { PERMISSIONS } from "../../PermissionsConstants";
import { accountAtom } from "../../Login/atoms/AccountAtom";
import {
  mainSelectedTab,
  permittedTabs,
} from "../../CarrierAgreementMgmt/atoms";
import { RedirectTo } from "../../../routes/RedirectTo";
import { useGetSecurityCount } from "../../CarrierAgreementMgmt/Security/hooks/useGetSecurityCounts";
import { OfficeTabs } from "../../OfficeTab/OfficeTabs";

const NewSecurityCard = () => {
  const [caCount, setCACount] = useState("...");
  const modulePermission = PERMISSIONS.permission_security_view;
  const userPermissions = useRecoilValue(permissionsSelector);
  const useraccount = useRecoilValue(accountAtom);

  const history = useHistory();
  const [connection, setConnection] = useState<any>(null);

  const [, setSelectedIndex] = useRecoilState(mainSelectedTab);
  const [usersTabs] = useRecoilState(permittedTabs);
  const { data: security } = useGetSecurityCount();

  const securityCounts = security?.map((x) => x.securityCount);

  return (
    <div
      className="p-2 pr-4 bg-white text-primary rounded-lg animate-fade-in-down2 shadow-md hover:text-white hover:bg-BrightNavyBlue"
      onClick={() => {
        if (userPermissions.includes(modulePermission)) {
          const urlPath = "/officesettings/security";
          history.push({
            pathname: urlPath,
          });
        }
      }}
    >
      <DashboardCard
        text="Security"
        count={securityCounts}
        image={
          <ShieldCheckIcon className="text-white bg-BrightNavyBlue rounded-md h-7 w-7 p-1" />
        }
        hasAccess={userPermissions.includes(modulePermission)}
      />
    </div>
  );
};

export default NewSecurityCard;
